let debounce = require('../../modules/debounce');
require('./height-limit.less');

let functions = require('../../modules/functions');

jQuery(function($) {
    var checkHeightLimitBlock = function($block) {
        if ($block == undefined) $block = $('.js-height-limit');

        //блок должен быть Jquery объектом а не какой-то левой фигней
        if ($block.bind !== $.prototype.bind) $block = $('.js-height-limit');

        if ($block.length == 0) return;

        if (!$block.hasClass('js-height-limit')) return;

        $block.each(function() {
            var $this = $(this);
            if ($this.hasClass('height-limit--full')) return;

            if (!$this.is(':visible')) return;

            var maxHeight = parseInt($this.css('max-height'));
            $this.removeClass('height-limit--visible');

            if ($this.innerHeight() < maxHeight) $this.addClass('height-limit--visible');
        });
    };

    $(document).on('click', '.js-height-limit-more', function(e) {
        e.preventDefault();
        var $block = $(this).closest('.height-limit');
        var trueHeight = functions.getTrueHeight($block);

        if ($block.hasClass('height-limit--full')) {
            $block.css('max-height', trueHeight);

            setTimeout(function() {
                $block.removeAttr('style');
                $block.removeClass('no-transition');
            }, 25);

            setTimeout(function() {
                $block.removeClass('height-limit--full');
            }, 400);
        } else {
            $block.css('max-height', trueHeight);

            setTimeout(function() {
                $block.addClass('height-limit--full no-transition').css('max-height', 'none');
            }, 400);
        }
    });

    debounce.setResizeDebounce(checkHeightLimitBlock);

    module.exports.checkHeightLimitBlock = checkHeightLimitBlock;
});



// WEBPACK FOOTER //
// ./blocks/height-limit/height-limit.js